import { TOGGLE_INSIGHTS, BOARD_INFO } from "../actions";

const initialState = { showInsights: false, boardInfo: null };

function reducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_INSIGHTS:
      return {
        ...state,
        showInsights: !state.showInsights
      };
    case BOARD_INFO:
      return {
        ...state,
        boardInfo: !state.boardInfo
      };
    default:
      return state;
  }
}

export default reducer;
